"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobMediaFileTypeEnum = void 0;
var JobMediaFileTypeEnum;
(function (JobMediaFileTypeEnum) {
    JobMediaFileTypeEnum["CANCELLATION_PICTURE"] = "cancellation_picture";
    JobMediaFileTypeEnum["CANCELLATION_PROTOCOL"] = "cancellation_protocol";
    JobMediaFileTypeEnum["CUSTOMER_SIGNOFF_FEEDBACK"] = "customer_signoff_feedback";
    JobMediaFileTypeEnum["CUSTOMER_BLUEPRINT"] = "customer_blueprint";
    JobMediaFileTypeEnum["PICTURE"] = "picture";
    JobMediaFileTypeEnum["PICTURE_AFTER"] = "picture_after";
    JobMediaFileTypeEnum["PICTURE_BEFORE"] = "picture_before";
    JobMediaFileTypeEnum["PLANNING_CUSTOMER"] = "planning_customer";
    JobMediaFileTypeEnum["PLANNING_PARTNER"] = "planning_partner";
    JobMediaFileTypeEnum["PROPAGATED_PROTOCOL"] = "propagated_protocol";
    JobMediaFileTypeEnum["PROTOCOL"] = "protocol";
    JobMediaFileTypeEnum["CUSTOMER_PROTOCOL"] = "customer_protocol";
    JobMediaFileTypeEnum["CUSTOMER_QUOTE"] = "customer_quote";
    JobMediaFileTypeEnum["BRAND_QUOTE"] = "brand_quote";
    JobMediaFileTypeEnum["METER_APPLICATION"] = "meter_application";
    JobMediaFileTypeEnum["CANCELLATION_PICTURE_BEFORE"] = "cancellation_picture_before";
    JobMediaFileTypeEnum["CANCELLATION_PICTURE_AFTER"] = "cancellation_picture_after";
    JobMediaFileTypeEnum["PROPOSAL_SIGN_OFF"] = "proposal_sign_off";
})(JobMediaFileTypeEnum = exports.JobMediaFileTypeEnum || (exports.JobMediaFileTypeEnum = {}));
//# sourceMappingURL=job-media-file-enum.js.map